import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TranslocoDirective } from '@jsverse/transloco';
import { ActionButtonsComponent } from '@modules/shared/action-buttons/action-buttons.component';
import { ShowIfUserAuthorizedDirective } from '@modules/shared/directives/show-if-user-authorized.directive';
import { UserPreviewComponent } from '@modules/user/user-preview/user-preview.component';
import { RelativeDatePipe } from '@shared/pipes/relative-date-pipe';
import { TuiHint } from '@taiga-ui/core';
import { SequenceLabelsListComponent } from '../sequence-labels-list/sequence-labels-list.component';
import { SequencePatientDisplayComponent } from '../sequence-patient-display/sequence-patient-display.component';
import { SequencePreviewTileMediaCarouselComponent } from '../sequence-preview-media-carousel/sequence-preview-tile-media-carousel.component';
import { SequenceReviewComponent } from '../sequence-review/sequence-review.component';
import { SequencePreviewComponent } from './sequence-preview.component';

@Component({
  selector: 'pxc-sequence-preview-tile',
  imports: [
    CommonModule,
    RouterModule,
    SequenceReviewComponent,
    RelativeDatePipe,
    UserPreviewComponent,
    ActionButtonsComponent,
    TranslocoDirective,
    SequenceLabelsListComponent,
    SequencePatientDisplayComponent,
    SequencePreviewTileMediaCarouselComponent,
    TuiHint,
    ShowIfUserAuthorizedDirective,
  ],
  templateUrl: './sequence-preview-tile.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'flex h-full w-full select-none flex-col',
  },
})
export class SequencePreviewTileComponent extends SequencePreviewComponent {}
